import { useQuery } from '@tanstack/react-query';

import { listCppRateCards } from '~/services/LuxLoyaltyService';

import type { CppRateCardListFilters } from '~/types/costPerPoint';

import { costPerPointQueryKeys } from './costPerPointQueryKeys';

interface UseSearchCppRateCardsOptions {
  enabled?: boolean;
}

/** Lists CPP rate cards with the given filters (partner/status). */
export function useSearchCppRateCards(filters: CppRateCardListFilters, options: UseSearchCppRateCardsOptions = {}) {
  const { enabled = true } = options;

  return useQuery({
    queryKey: costPerPointQueryKeys.list(filters),
    queryFn: async ({ signal }) => {
      return await listCppRateCards(filters, { signal });
    },
    placeholderData: (previousData) => previousData,
    enabled,
    retry: false,
  });
}
